import { render, staticRenderFns } from "./CinemaButton.vue?vue&type=template&id=042d3c96&scoped=true&"
import script from "./CinemaButton.vue?vue&type=script&lang=js&"
export * from "./CinemaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d3c96",
  null
  
)

export default component.exports